import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from './AuthProvider';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (auth.status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center text-body text-leaf-soft">
        {t('common.loading')}
      </div>
    );
  }
  if (auth.status === 'signedOut') {
    return <Navigate to="/signin" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}
